import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'
import { InfiniteScroll } from 'components/shared/InfiniteScoll/InfiniteScroll'
import { LabelWithTooltip } from 'components/shared/LabelWithTooltip/LabelWithTooltip'
import { TemplateCard } from 'components/shared/TemplateCard/TemplateCard'

import { SEARCH_NAME_FIELD } from './model'

import styles from './TemplateSearch.module.scss'

export const TemplateSearch = React.forwardRef(
  (
    { activeTemplate, control, templates, handleActiveTemplate, isPending },
    ref,
  ) => (
    <aside className={styles.templates}>
      <header className={styles.header}>
        <LabelWithTooltip
          className={styles.templateHeader}
          tooltip={t`A list of existing templates for jobs.`}
        >
          {t`Templates`}
        </LabelWithTooltip>
        <Form>
          <Form.Field
            className={styles.input}
            field="input"
            name={SEARCH_NAME_FIELD}
            placeholder={t`Search...`}
            {...{ control }}
          />
        </Form>
      </header>
      <InfiniteScroll {...{ isPending }}>
        {R.addIndex(R.map)(
          (template, index) => (
            <InfiniteScroll.Item
              key={template.id}
              ref={templates.length === index + 1 ? ref : null}
            >
              <TemplateCard
                onClick={() => handleActiveTemplate(template)}
                isActive={R.equals(activeTemplate?.id, template.id)}
              >
                {template.name}
              </TemplateCard>
            </InfiniteScroll.Item>
          ),
          templates ?? [],
        )}
      </InfiniteScroll>
    </aside>
  ),
)
